import { render, staticRenderFns } from "./AreaDialog.vue?vue&type=template&id=338b5538&"
import script from "./AreaDialog.vue?vue&type=script&lang=js&"
export * from "./AreaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports